module.exports = __webpack_public_path__ + "static/img/魏牌蓝山.9f25bfea.png";